// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.4766 1.01014C12.3186 1.0034 12.1597 1 12 1C5.92487 1 1 5.92487 1 12C1 17.5603 5.12559 22.1571 10.4827 22.8962L12.4519 18.0218L12.4318 17.9816C12.2895 17.9938 12.1455 18 12 18C10.1481 18 8.53256 16.9926 7.66955 15.5007L7.16882 14.6351L8.90004 13.6337L9.40076 14.4993C9.82666 15.2355 10.5539 15.7721 11.4123 15.9425L10.441 13.9999L12.441 9.99994L10.4519 6.0218L12.4766 1.01014ZM9 8V12H7V8H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.452 17.7858C14.6772 17.4145 15.7028 16.5858 16.3305 15.5007L16.8312 14.6351L15.1 13.6337L14.5993 14.4993C14.1647 15.2505 13.4164 15.7938 12.5353 15.9524L11.559 13.9999L13.559 9.99994L11.5481 5.97809L13.5173 1.10379C18.8744 1.84288 23 6.43964 23 12C23 18.0751 18.0751 23 12 23C11.8403 23 11.6814 22.9966 11.5234 22.9899L13.5481 17.9781L13.452 17.7858ZM17 8H15V12H17V8Z"}}]};

const CrackFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'crack-filled',
    ref,
    icon: element,
  },
));

CrackFilledIcon.displayName = 'CrackFilledIcon';

export default CrackFilledIcon;
